import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ViCardComponent } from '../card/card.component';
import { MatIconModule } from '@angular/material/icon';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';
@Component({
  selector: 'vi-panel',
  standalone: true,
  imports: [CommonStandaloneModule, ViCardComponent, MatIconModule],
  templateUrl: 'panel.component.html',
  styleUrls: ['panel.component.scss'],
  animations: [
    trigger('toggle', [
      state('*', style({ 'overflow-y': 'hidden' })),
      state('void', style({ 'overflow-y': 'hidden' })),
      transition('* => void', [style({ height: '*' }), animate(300, style({ height: '0' }))]),
      transition('void => *', [style({ height: '0' }), animate(300, style({ height: '*' }))]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ViPanelComponent {
  @Input() title: string;
  @Input() isExpandable: Boolean = false;
  @Input() isExpanded: Boolean = false;
  @Input() isShadow: Boolean = true;

  @Output() expand: EventEmitter<void> = new EventEmitter<void>();
  @Output() collapse: EventEmitter<void> = new EventEmitter<void>();

  toggleExpansion(): void {
    if (this.isExpandable) {
      this.isExpanded = !this.isExpanded;
      if (this.isExpanded) {
        this.expand.emit();
      } else {
        this.collapse.emit();
      }
    }
  }
}
